import React, { useContext } from "react";

import { Navigate, useLocation } from "react-router-dom";

import { AuthStateContext } from "@/contexts/AuthContext";

const ReportV2TrainingRedirect: React.FC = () => {
  const { currentUser } = useContext(AuthStateContext);
  const location = useLocation();
  const orgId = currentUser?.rubi_org_id;

  return (
    <Navigate
      to={
        orgId
          ? {
              pathname: `/rubireportv2/${orgId}/training`,
              search: location.search,
              hash: location.hash,
            }
          : "/"
      }
      replace
      state={location.state}
    />
  );
};

export default ReportV2TrainingRedirect;
